import { render, staticRenderFns } from "./SeletorDeLojas.vue?vue&type=template&id=a5ce11ea"
import script from "./SeletorDeLojas.vue?vue&type=script&setup=true&lang=ts"
export * from "./SeletorDeLojas.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports